import {
  ADD_ROUTE,
  ADD_COST,
  ADD_HOME,
  DELETE_ROUTE,
  LOAD_ROUTES,
  SUBTRACT_COST,
  SUBTRACT_HOME,
  ACTIVE_ROUTE,
  DEACTIVE_ROUTE,
  CLEAR_TABLE,
  CONTROL_COLLAPSE,
  ADD_BUSINESS,
  SUBTRACT_BUSINESS,
  EXCLUDED_BUSINESS,
  HOVERED_ROUTE, UNHOVERED_ROUTE, RESET_SELECTED_ROUTES
} from '../actions-types';

const initialState = {
  isLoading: true,
  routes: [],
  homes: 0,
  costs: 0,
  business: 0,
  collapse: false,
  selectedRoutes: [],
  excludedBusiness: false,
  hoveredRoute: {}
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ROUTES:
      return {
        ...state,
        routes: [...state.routes, ...action.payload]
      };
    case ACTIVE_ROUTE:
      return {
        ...state,
        routes: state.routes.map((route) => {
          if (route.attributes.ZIP_CRID === action.payload) {
            return {
              ...route,
              active: true
            };
          } else {
            return {
              ...route
            };
          }
        })
      };
    case DEACTIVE_ROUTE:
      return {
        ...state,
        routes: state.routes.map((route) => {
          if (route.attributes.ZIP_CRID === action.payload) {
            return {
              ...route,
              active: false
            };
          } else {
            return {
              ...route
            };
          }
        })
      };
    case ADD_ROUTE:
      return {
        ...state,
        selectedRoutes: [...state.selectedRoutes, {...action.payload}]
      };
    case DELETE_ROUTE:
      return {
        ...state,
        selectedRoutes: state.selectedRoutes.filter((route) => route.ZIP_CRID !== action.payload)
      };
    case ADD_COST:
      return {
        ...state,
        costs: state.costs + action.payload
      };
    case SUBTRACT_COST:
      return {
        ...state,
        costs: state.costs - action.payload
      };
    case ADD_HOME:
      return {
        ...state,
        homes: state.homes + action.payload
      };
    case SUBTRACT_HOME:
      return {
        ...state,
        homes: state.homes - action.payload
      };
    case CLEAR_TABLE:
      return {
        isLoading: false,
        routes: [],
        homes: 0,
        costs: 0,
        business: 0,
        collapse: false,
        selectedRoutes: [],
        excludedBusiness: false
      };
    case CONTROL_COLLAPSE:
      return {
        ...state,
        collapse: !state.collapse
      };
    case ADD_BUSINESS:
      return {
        ...state,
        business: state.business + action.payload
      };
    case SUBTRACT_BUSINESS:
      return {
        ...state,
        business: state.business - action.payload
      };
    case EXCLUDED_BUSINESS:
      return {
        ...state,
        excludedBusiness: !state.excludedBusiness
      };
    case HOVERED_ROUTE:
      return {
        ...state,
        hoveredRoute: action.payload
      };
    case UNHOVERED_ROUTE:
      return {
        ...state,
        hoveredRoute: {}
      };
    case RESET_SELECTED_ROUTES:
      return {
        ...state,
        routes: state.routes.map(route => {
          route.active = false;
          return route;
        }),
        homes: 0,
        costs: 0,
        business: 0
      };
    default:
      return state;
  }
};
